<div class="message-area">
	@if (showMenuToggle()) {
		<div class="message-area-header">
			<button class="mobile-menu-toggle" (click)="toggleMenu()" aria-label="Open conversation list">
				<md-icon [icon]="'untitled-ui/general/menu-01'"></md-icon>
			</button>
			<div class="header-content">
				<md-icon [icon]="'untitled-ui/communication/message-chat-circle'"></md-icon>
				<md-header size="sm">{{ conversation().title }}</md-header>
			</div>
		</div>
	}

	<div class="messages-container" #messagesContainer>
		@if (messages().length === 0 && !loading()) {
			<div class="no-messages">
				<md-icon [icon]="'untitled-ui/communication/message-chat-circle'"></md-icon>
				<span>Start a conversation with the AI assistant</span>
			</div>
		} @else {
			@for (message of messages(); track message.id) {
				<lb-chat-message [message]="message" [userInitials]="userInitials()" (retryMessage)="onRetryMessage($event)" />
			}
			@if (loading()) {
				<div class="loading-indicator">
					<lb-loader [message]="'AI is thinking...'" [size]="'small'" />
				</div>
			}
		}
	</div>

	<lb-chat-message-input (messageSent)="onMessageSent($event)" />
</div>
